function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 119,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 119,
  width: 119,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 238,
  width: 119,
  height: 145,
  fill: "#222222",
  fillOpacity: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M119 0V145",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M237 0V145",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.104 78H41.196V71.484H40.104V78ZM40.656 70.14C41.088 70.14 41.388 69.852 41.388 69.408C41.388 68.988 41.088 68.7 40.656 68.7C40.224 68.7 39.924 68.988 39.924 69.408C39.924 69.852 40.224 70.14 40.656 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4087 78H44.5007V73.272C45.1007 72.6 45.6527 72.276 46.1447 72.276C46.9727 72.276 47.3567 72.792 47.3567 74.016V78H48.4487V73.272C49.0607 72.6 49.5887 72.276 50.0927 72.276C50.9207 72.276 51.3047 72.792 51.3047 74.016V78H52.3967V73.872C52.3967 72.204 51.7607 71.316 50.4167 71.316C49.6247 71.316 48.9407 71.832 48.2687 72.564C48.0047 71.796 47.4647 71.316 46.4687 71.316C45.6887 71.316 45.0047 71.808 44.4407 72.432H44.4047L44.3087 71.484H43.4087V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0181 78.156C56.8221 78.156 57.5541 77.736 58.1781 77.22H58.2141L58.3101 78H59.2101V73.992C59.2101 72.384 58.5381 71.316 56.9541 71.316C55.9101 71.316 54.9861 71.784 54.3861 72.168L54.8181 72.924C55.3341 72.576 56.0181 72.228 56.7741 72.228C57.8421 72.228 58.1181 73.032 58.1181 73.872C55.3461 74.184 54.1101 74.892 54.1101 76.308C54.1101 77.484 54.9261 78.156 56.0181 78.156ZM56.3301 77.28C55.6821 77.28 55.1781 76.98 55.1781 76.236C55.1781 75.396 55.9221 74.856 58.1181 74.592V76.416C57.4821 76.98 56.9661 77.28 56.3301 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M63.4875 81C65.5035 81 66.7875 79.956 66.7875 78.744C66.7875 77.676 66.0195 77.196 64.5075 77.196H63.2355C62.3595 77.196 62.0955 76.908 62.0955 76.488C62.0955 76.128 62.2755 75.912 62.5155 75.708C62.8035 75.852 63.1635 75.936 63.4875 75.936C64.8075 75.936 65.8635 75.06 65.8635 73.668C65.8635 73.104 65.6475 72.624 65.3355 72.324H66.6675V71.484H64.3995C64.1715 71.4 63.8475 71.316 63.4875 71.316C62.1675 71.316 61.0395 72.216 61.0395 73.644C61.0395 74.424 61.4595 75.048 61.8915 75.396V75.444C61.5555 75.684 61.1595 76.116 61.1595 76.656C61.1595 77.172 61.4115 77.52 61.7595 77.724V77.772C61.1475 78.168 60.7995 78.696 60.7995 79.248C60.7995 80.376 61.8915 81 63.4875 81ZM63.4875 75.192C62.7315 75.192 62.0955 74.592 62.0955 73.644C62.0955 72.684 62.7195 72.12 63.4875 72.12C64.2555 72.12 64.8795 72.696 64.8795 73.644C64.8795 74.592 64.2315 75.192 63.4875 75.192ZM63.6435 80.256C62.4675 80.256 61.7595 79.8 61.7595 79.104C61.7595 78.72 61.9515 78.336 62.4195 78C62.7075 78.072 63.0195 78.108 63.2595 78.108H64.3875C65.2515 78.108 65.7195 78.312 65.7195 78.912C65.7195 79.596 64.8915 80.256 63.6435 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M70.5054 78.156C71.3934 78.156 72.0895 77.856 72.6655 77.484L72.2695 76.764C71.7895 77.088 71.2734 77.28 70.6374 77.28C69.4014 77.28 68.5494 76.392 68.4774 75H72.8694C72.8935 74.844 72.9174 74.616 72.9174 74.376C72.9174 72.516 71.9814 71.316 70.3254 71.316C68.8134 71.316 67.3854 72.636 67.3854 74.748C67.3854 76.896 68.7774 78.156 70.5054 78.156ZM68.4654 74.208C68.5974 72.936 69.4134 72.192 70.3375 72.192C71.3575 72.192 71.9575 72.9 71.9575 74.208H68.4654Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M74.474 78H79.298V77.088H77.534V69.444H76.694C76.214 69.732 75.65 69.936 74.87 70.068V70.776H76.43V77.088H74.474V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M159.104 78H160.196V71.484H159.104V78ZM159.656 70.14C160.088 70.14 160.388 69.852 160.388 69.408C160.388 68.988 160.088 68.7 159.656 68.7C159.224 68.7 158.924 68.988 158.924 69.408C158.924 69.852 159.224 70.14 159.656 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M162.409 78H163.501V73.272C164.101 72.6 164.653 72.276 165.145 72.276C165.973 72.276 166.357 72.792 166.357 74.016V78H167.449V73.272C168.061 72.6 168.589 72.276 169.093 72.276C169.921 72.276 170.305 72.792 170.305 74.016V78H171.397V73.872C171.397 72.204 170.761 71.316 169.417 71.316C168.625 71.316 167.941 71.832 167.269 72.564C167.005 71.796 166.465 71.316 165.469 71.316C164.689 71.316 164.005 71.808 163.441 72.432H163.405L163.309 71.484H162.409V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M175.018 78.156C175.822 78.156 176.554 77.736 177.178 77.22H177.214L177.31 78H178.21V73.992C178.21 72.384 177.538 71.316 175.954 71.316C174.91 71.316 173.986 71.784 173.386 72.168L173.818 72.924C174.334 72.576 175.018 72.228 175.774 72.228C176.842 72.228 177.118 73.032 177.118 73.872C174.346 74.184 173.11 74.892 173.11 76.308C173.11 77.484 173.926 78.156 175.018 78.156ZM175.33 77.28C174.682 77.28 174.178 76.98 174.178 76.236C174.178 75.396 174.922 74.856 177.118 74.592V76.416C176.482 76.98 175.966 77.28 175.33 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M182.487 81C184.503 81 185.787 79.956 185.787 78.744C185.787 77.676 185.019 77.196 183.507 77.196H182.235C181.359 77.196 181.095 76.908 181.095 76.488C181.095 76.128 181.275 75.912 181.515 75.708C181.803 75.852 182.163 75.936 182.487 75.936C183.807 75.936 184.863 75.06 184.863 73.668C184.863 73.104 184.647 72.624 184.335 72.324H185.667V71.484H183.399C183.171 71.4 182.847 71.316 182.487 71.316C181.167 71.316 180.039 72.216 180.039 73.644C180.039 74.424 180.459 75.048 180.891 75.396V75.444C180.555 75.684 180.159 76.116 180.159 76.656C180.159 77.172 180.411 77.52 180.759 77.724V77.772C180.147 78.168 179.799 78.696 179.799 79.248C179.799 80.376 180.891 81 182.487 81ZM182.487 75.192C181.731 75.192 181.095 74.592 181.095 73.644C181.095 72.684 181.719 72.12 182.487 72.12C183.255 72.12 183.879 72.696 183.879 73.644C183.879 74.592 183.231 75.192 182.487 75.192ZM182.643 80.256C181.467 80.256 180.759 79.8 180.759 79.104C180.759 78.72 180.951 78.336 181.419 78C181.707 78.072 182.019 78.108 182.259 78.108H183.387C184.251 78.108 184.719 78.312 184.719 78.912C184.719 79.596 183.891 80.256 182.643 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M189.505 78.156C190.393 78.156 191.089 77.856 191.665 77.484L191.269 76.764C190.789 77.088 190.273 77.28 189.637 77.28C188.401 77.28 187.549 76.392 187.477 75H191.869C191.893 74.844 191.917 74.616 191.917 74.376C191.917 72.516 190.981 71.316 189.325 71.316C187.813 71.316 186.385 72.636 186.385 74.748C186.385 76.896 187.777 78.156 189.505 78.156ZM187.465 74.208C187.597 72.936 188.413 72.192 189.337 72.192C190.357 72.192 190.957 72.9 190.957 74.208H187.465Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M192.946 78H198.478V77.052H195.994C195.538 77.052 195.01 77.1 194.554 77.136C196.582 75 198.046 73.404 198.046 71.796C198.046 70.284 197.062 69.288 195.49 69.288C194.374 69.288 193.618 69.804 192.898 70.584L193.534 71.196C194.014 70.632 194.638 70.176 195.358 70.176C196.45 70.176 196.978 70.872 196.978 71.844C196.978 73.248 195.526 74.784 192.946 77.352V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M277.104 78H278.196V71.484H277.104V78ZM277.656 70.14C278.088 70.14 278.388 69.852 278.388 69.408C278.388 68.988 278.088 68.7 277.656 68.7C277.224 68.7 276.924 68.988 276.924 69.408C276.924 69.852 277.224 70.14 277.656 70.14Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M280.409 78H281.501V73.272C282.101 72.6 282.653 72.276 283.145 72.276C283.973 72.276 284.357 72.792 284.357 74.016V78H285.449V73.272C286.061 72.6 286.589 72.276 287.093 72.276C287.921 72.276 288.305 72.792 288.305 74.016V78H289.397V73.872C289.397 72.204 288.761 71.316 287.417 71.316C286.625 71.316 285.941 71.832 285.269 72.564C285.005 71.796 284.465 71.316 283.469 71.316C282.689 71.316 282.005 71.808 281.441 72.432H281.405L281.309 71.484H280.409V78Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M293.018 78.156C293.822 78.156 294.554 77.736 295.178 77.22H295.214L295.31 78H296.21V73.992C296.21 72.384 295.538 71.316 293.954 71.316C292.91 71.316 291.986 71.784 291.386 72.168L291.818 72.924C292.334 72.576 293.018 72.228 293.774 72.228C294.842 72.228 295.118 73.032 295.118 73.872C292.346 74.184 291.11 74.892 291.11 76.308C291.11 77.484 291.926 78.156 293.018 78.156ZM293.33 77.28C292.682 77.28 292.178 76.98 292.178 76.236C292.178 75.396 292.922 74.856 295.118 74.592V76.416C294.482 76.98 293.966 77.28 293.33 77.28Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M300.488 81C302.504 81 303.788 79.956 303.788 78.744C303.788 77.676 303.02 77.196 301.508 77.196H300.236C299.36 77.196 299.096 76.908 299.096 76.488C299.096 76.128 299.276 75.912 299.516 75.708C299.804 75.852 300.164 75.936 300.488 75.936C301.808 75.936 302.864 75.06 302.864 73.668C302.864 73.104 302.648 72.624 302.336 72.324H303.668V71.484H301.4C301.172 71.4 300.848 71.316 300.488 71.316C299.168 71.316 298.04 72.216 298.04 73.644C298.04 74.424 298.46 75.048 298.892 75.396V75.444C298.556 75.684 298.16 76.116 298.16 76.656C298.16 77.172 298.412 77.52 298.76 77.724V77.772C298.148 78.168 297.8 78.696 297.8 79.248C297.8 80.376 298.892 81 300.488 81ZM300.488 75.192C299.732 75.192 299.096 74.592 299.096 73.644C299.096 72.684 299.72 72.12 300.488 72.12C301.256 72.12 301.88 72.696 301.88 73.644C301.88 74.592 301.232 75.192 300.488 75.192ZM300.644 80.256C299.468 80.256 298.76 79.8 298.76 79.104C298.76 78.72 298.952 78.336 299.42 78C299.708 78.072 300.02 78.108 300.26 78.108H301.388C302.252 78.108 302.72 78.312 302.72 78.912C302.72 79.596 301.892 80.256 300.644 80.256Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M307.506 78.156C308.394 78.156 309.09 77.856 309.666 77.484L309.27 76.764C308.79 77.088 308.274 77.28 307.638 77.28C306.402 77.28 305.55 76.392 305.478 75H309.87C309.894 74.844 309.918 74.616 309.918 74.376C309.918 72.516 308.982 71.316 307.326 71.316C305.814 71.316 304.386 72.636 304.386 74.748C304.386 76.896 305.778 78.156 307.506 78.156ZM305.466 74.208C305.598 72.936 306.414 72.192 307.338 72.192C308.358 72.192 308.958 72.9 308.958 74.208H305.466Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M313.586 78.156C315.146 78.156 316.406 77.244 316.406 75.72C316.406 74.544 315.578 73.788 314.546 73.536V73.488C315.47 73.152 316.106 72.492 316.106 71.46C316.106 70.068 315.026 69.288 313.55 69.288C312.53 69.288 311.75 69.732 311.09 70.356L311.678 71.04C312.17 70.536 312.794 70.176 313.502 70.176C314.414 70.176 314.99 70.704 314.99 71.532C314.99 72.432 314.366 73.14 312.554 73.14V73.98C314.582 73.98 315.29 74.652 315.29 75.672C315.29 76.632 314.546 77.244 313.502 77.244C312.506 77.244 311.834 76.776 311.318 76.236L310.766 76.956C311.342 77.58 312.206 78.156 313.586 78.156Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var Svg3BannersGrey = function Svg3BannersGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 145,
    viewBox: "0 0 357 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3BannersGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3banners_grey.dcf9010a.svg";
export { ForwardRef as ReactComponent };